import React from "react";
import styled from "styled-components";
import { Typography } from "@material-ui/core";

const ColumnHeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding-bottom: 10px;
    padding-right: 15px;
    width: auto;
    && >* {
      color: #5F6368;
      font-family: "Work Sans";
      font-weight: 550;
    }
`;

const StyledAsOfDate = styled(Typography)`
  padding-left: 33px;
`;

const StyledAssignee = styled(Typography)`
  padding-left: 50px;
`;

const StyledSubmittedDate = styled(Typography)`
  padding-left: 747px;
`;


const SubmittedReportsColumnHeader = () => {
  return (
    <ColumnHeaderContainer>
      <StyledAsOfDate>AS OF DATE</StyledAsOfDate>
      <StyledSubmittedDate>SUBMITTED DATE</StyledSubmittedDate>
      <StyledAssignee>ASSIGNEE</StyledAssignee>
    </ColumnHeaderContainer>
  );
};

export default SubmittedReportsColumnHeader;